import React, { Component } from "react";
import "./Configuration.css";
import { Modal, ModalHeader, ModalFooter, DropdownItem } from "reactstrap";

export default class CSVModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeConfig: this.props.configItem,
      dropdown: false,
      isValid: true,
      validationErrors: [],
      generated: false,
      nodeUUID: "",
    };
  }

  validateInput = () => {
    const eid = this.state.activeConfig.eid;
    const private_ip = this.state.activeConfig.private_ip;
    const length = this.state.activeConfig.length;

    let errors = [];
    if (eid === null) {
      errors.push(<li key={"eid"}>Host node selection required</li>);
    }
    if (private_ip === "") {
      errors.push(<li key={"private_ip"}>IP address required</li>);
    } else if (
      !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        private_ip
      )
    ) {
      errors.push(<li key={"private_ip"}>Entered IP address is not valid</li>);
    }
    if (length === "") {
      errors.push(<li key={"length"}>Contact length required</li>);
    }
    if (!/^[0-9]*$/.test(length)) {
      errors.push(<li key={"length"}>Contact length must be numerical</li>);
    }

    if (errors.length > 0) {
      this.setState({ isValid: false, validationErrors: errors });
      return false;
    }
    this.setState({ isValid: true, validationErrors: [] });
    return true;
  };

  handleChange = async (e) => {
    let { name, value } = e.target;
    const activeConfig = { ...this.state.activeConfig, [name]: value };
    await this.setState({ activeConfig });
  };

  renderHosts = () => {
    const hosts = this.props.nodeList;
    const user = this.props.user;

    return hosts.map((item) =>
      item.owner === user ? (
        <DropdownItem
          className="dropdown_item"
          key={item.eid}
          onClick={() => this.setLastClicked(item)}
        >
          Node {item.eid}
        </DropdownItem>
      ) : null
    );
  };

  dropdownToggle = () => {
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const { baseUrl, token, toggle, toggleName, network_uuid, downloadCSV } =
      this.props;

    return (
      <Modal
        modalClassName="Modal"
        isOpen={true}
        toggle={function () {
          return toggle(toggleName);
        }}
      >
        <ModalHeader>
          CSV Download
          <button className="exit_close_button" onClick={()=>{toggle(toggleName)}}>
            ×
          </button>
        </ModalHeader>
        <ModalFooter>
          <>
            <div className="generated_area">
              <h4 style={{ color: "#60f056" }}>API Call</h4>
              <code style={{ color: "white" }}>
                {`curl --location --request GET '${baseUrl}/api/api/network/nodes_csv?uuid=${network_uuid}' --header 'Authorization: Token ${token}'`}
              </code>
            </div>
            <button
              className="download_button"
              onClick={() => {
                downloadCSV(network_uuid);
              }}
            >
              Download CSV
            </button>
          </>
        </ModalFooter>
      </Modal>
    );
  }
}
